import * as Sentry from '@sentry/react';

// Inert when REACT_APP_SENTRY_DSN is unset (local dev, PR previews, etc.).
// Keeps the browser bundle quiet and avoids reporting fake errors.
const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production',
    release: process.env.REACT_APP_SENTRY_RELEASE,
    // Browser performance tracing (keep sample rate low in prod so we don't
    // flood the free tier). Bump via env var for debugging.
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
    integrations: [Sentry.browserTracingIntegration()],
    // Don't ship Supabase LockManager noise — those rejections are internal
    // auto-refresh retries, not real user-facing errors.
    ignoreErrors: [
      /Navigator ?Locks? Manager/i,
      /auth-token.*lock.*failed/i,
      /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/,
    ],
    beforeSend(event, hint) {
      const msg = String(hint?.originalException?.message || event?.message || '');
      if (/navigator ?locks|LockManager|auth-token.*lock/i.test(msg)) return null;
      return event;
    },
  });
}

export default Sentry;
